import { FILTERS, DEFAULT_FILTER_OPTIONS } from '../../../../../common/filters/constants';
import { getBeginningOfDay } from '../../../../../../constants/helpers/dates';

import { AccountTransfersBillingFilters } from './interfaces';

export const initFilters: AccountTransfersBillingFilters = {
  [FILTERS.PAGE_SIZE]: DEFAULT_FILTER_OPTIONS.PAGE_SIZE,
  [FILTERS.FROM]: getBeginningOfDay(),
  [FILTERS.TO]: 'now',
  [FILTERS.OPERATION_ID]: [],
  [FILTERS.STATUS]: [],
  [FILTERS.MSISDN]: []
};

export const activeFiltersCountMapper = (activeFilters: AccountTransfersBillingFilters) => {
  let availableFiltersCount = 0;

  if (activeFilters.operation_id?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.status?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.msisdn?.length > 0) {
    availableFiltersCount += 1;
  }

  return availableFiltersCount;
};
